import './styles.css';

/** Landing page — match app WA dark theme (html already has wa-dark). */
document.documentElement.classList.add('wa-theme-active', 'wa-dark', 'js');
